import {
  HttpClient,
  HttpErrorResponse
} from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import {
  Observable,
  catchError,
  map,
  throwError,
} from 'rxjs';
import { environment } from 'src/environments/environment';

import { Fee } from 'src/models/Fee.interface';
import { Client } from 'src/models/Client.interface';
import { ListCrmClients } from 'src/models/Crm-client.interface';
import { CsvData } from 'src/models/CsvData.interface';
import { Contact, ContactListResponse } from 'src/models/Contacts.interface';

@Injectable({
  providedIn: 'root',
})
export class HomeService {
  public rolEmitter: EventEmitter<string> = new EventEmitter();
  public selectedProviderId: number | undefined;

  constructor(
    private http: HttpClient,
  ) { }




  getListFees(clientData: any, page: number): Observable<Fee[]> {
    const url = `${environment.API_URL}/api/v1/crm/fees?page=${page}`;
    return this.http
      .get<any>(url, { params: clientData })
      .pipe(map((response) => response.results));
  }

  createFee(fee: Fee): Observable<any> {
    const url = `${environment.API_URL}/api/v1/crm/fees`;
    return this.http.post<any>(url, fee);
  }


  getClients(page: number): Observable<ListCrmClients> {
    const url = `${environment.API_URL}/api/v1/crm/clients?page=${page}`;
    return this.http.get<ListCrmClients>(url);
  }





  // bulkCreateClients(csvData: Blob) {
  //   const formData = new FormData();
  //   formData.append('file', csvData);
  //   const url = `${environment.API_URL}/api/v1/crm/clients/bulk`;
  //   return this.http.post<CsvData>(url, formData);
  // }




  private handleError(error: HttpErrorResponse) {
    let userMessage = 'Something bad happened; please try again later.';
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.error(
        `Backend returned code ${error.status}, body was: ${error.error}`
      );
      userMessage = `Error: ${error.status} ${error.statusText}`;
    }
    return throwError(() => new Error(userMessage));
  }


  getDashboardData(): Observable<any> {
    const url = `${environment.API_URL}/api/v1/dashboard`;
    return this.http.get<any>(url).pipe(catchError(this.handleError));
  }

}
